import QuoteContainer from "./container";

export default QuoteContainer;
